export enum ModeInfoPanelEnum {
  Info,
  Problems,
}
